export default (slots) => ({
  isSlotEmpty (name, scope = {}) {
    if (!slots[name]) {
      return true
    }

    const slotContent = slots[name](scope)
    return slotContent.length === 0
  }
})
